export default [
    {
        path: 'post/list',
        name: 'organization_post_list',
        meta: { isCache: true, icon: 'md-school', hideInMenu: false },
        component: () => import('@/views/organization/post/post-list.vue'),
    },
    {
        path: 'post/add',
        name: 'organization_post_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/organization/post/post-add.vue'),
    },
    {
        path: 'post/edit/:id',
        name: 'organization_post_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/organization/post/post-edit.vue'),
    },
    {
        path: 'post/detail/:id',
        name: 'organization_post_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/organization/post/post-detail.vue'),
    },
];
